// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type IssueDetailQueryVariables = Types.Exact<{
  issueId: Types.Scalars["ID"]["input"];
}>;

export type IssueDetailQuery = {
  __typename?: "GraphqlQuery";
  getIssue: {
    __typename?: "Issue";
    id: string;
    checkGroupAndName: string;
    descriptionTemplate: string;
    state: string;
    createdAt: number;
    updatedAt: number;
    severity: string;
    databaseId?: string | null;
    permittedToModify: boolean;
    details: any;
    descriptionReferences: Array<{
      __typename?: "IssueDescriptionReference";
      param: string;
      name: string;
      path?: string | null;
    }>;
    server: {
      __typename?: "Server";
      id: string;
      name: string;
      humanId: string;
      blockSize: number;
    };
    checkConfig: {
      __typename?: "CheckConfig";
      enabled: boolean;
      settings: any;
    };
    references: Array<{
      __typename?: "IssueReference";
      createdAt: number;
      name: string;
      kind: string;
      url: string;
      details: any;
      queryText?: string | null;
      referent?:
        | { __typename?: "Backend"; id: string; pid: number }
        | { __typename?: "Database"; id: string; datname?: string | null }
        | { __typename?: "PostgresSetting" }
        | { __typename?: "Query"; id: string }
        | {
            __typename?: "QueryExplain";
            id: string;
            humanId: string;
            runtimeMs?: number | null;
          }
        | { __typename?: "ReplicationFollower"; id: string }
        | {
            __typename?: "SchemaIndex";
            id: string;
            name: string;
            schemaName: string;
            tableId: string;
            sizeBytes?: number | null;
          }
        | {
            __typename?: "SchemaTable";
            id: string;
            tableName: string;
            schemaName: string;
            databaseId: string;
          }
        | { __typename?: "SchemaTableScan"; id: string }
        | { __typename?: "Server" }
        | {
            __typename?: "VacuumRun";
            id: string;
            identity: string;
            databaseId: string;
            schemaTableId?: string | null;
            vacuumStart: number;
            vacuumEnd?: number | null;
          }
        | null;
    }>;
    activity: Array<{
      __typename?: "IssueActivity";
      id: string;
      occurredAt: number;
      kind: Types.ActivityKind;
      description?: string | null;
      severity?: string | null;
      user?: {
        __typename?: "User";
        id: string;
        avatarUrl?: string | null;
        fullname?: string | null;
      } | null;
    }>;
  };
};

export const IssueDetailDocument = gql`
  query IssueDetail($issueId: ID!) {
    getIssue(issueId: $issueId) {
      id
      checkGroupAndName
      descriptionTemplate
      descriptionReferences {
        param
        name
        path
      }
      state
      createdAt
      updatedAt
      severity
      databaseId
      server {
        id
        name
        humanId
        blockSize
      }
      checkConfig {
        enabled
        settings
      }
      permittedToModify
      details
      references {
        createdAt
        name
        kind
        url
        details
        queryText
        referent {
          ... on Backend {
            id
            pid
          }
          ... on SchemaIndex {
            id
            name
            schemaName
            tableId
            sizeBytes
          }
          ... on Query {
            id
          }
          ... on ReplicationFollower {
            id
          }
          ... on QueryExplain {
            id
            humanId
            runtimeMs
          }
          ... on SchemaTable {
            id
            tableName
            schemaName
            databaseId
          }
          ... on SchemaTableScan {
            id
          }
          ... on VacuumRun {
            id
            identity
            databaseId
            schemaTableId
            vacuumStart
            vacuumEnd
          }
          ... on Database {
            id
            datname
          }
        }
      }
      activity {
        id
        occurredAt
        kind
        description
        severity
        user {
          id
          avatarUrl
          fullname
        }
      }
    }
  }
`;

/**
 * __useIssueDetailQuery__
 *
 * To run a query within a React component, call `useIssueDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssueDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssueDetailQuery({
 *   variables: {
 *      issueId: // value for 'issueId'
 *   },
 * });
 */
export function useIssueDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    IssueDetailQuery,
    IssueDetailQueryVariables
  > &
    (
      | { variables: IssueDetailQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IssueDetailQuery, IssueDetailQueryVariables>(
    IssueDetailDocument,
    options,
  );
}
export function useIssueDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IssueDetailQuery,
    IssueDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IssueDetailQuery, IssueDetailQueryVariables>(
    IssueDetailDocument,
    options,
  );
}
// @ts-ignore
export function useIssueDetailSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IssueDetailQuery,
    IssueDetailQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IssueDetailQuery, IssueDetailQueryVariables>;
export function useIssueDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IssueDetailQuery,
        IssueDetailQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IssueDetailQuery | undefined,
  IssueDetailQueryVariables
>;
export function useIssueDetailSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IssueDetailQuery,
        IssueDetailQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IssueDetailQuery, IssueDetailQueryVariables>(
    IssueDetailDocument,
    options,
  );
}
export type IssueDetailQueryHookResult = ReturnType<typeof useIssueDetailQuery>;
export type IssueDetailLazyQueryHookResult = ReturnType<
  typeof useIssueDetailLazyQuery
>;
export type IssueDetailSuspenseQueryHookResult = ReturnType<
  typeof useIssueDetailSuspenseQuery
>;
export type IssueDetailQueryResult = Apollo.QueryResult<
  IssueDetailQuery,
  IssueDetailQueryVariables
>;
